import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./lib/app/App";
import SocketProvider from "./SocketProvider";
import BookingReminderPoller from "./lib/components/BookingReminderPoller";
import BirthdayPoller from "./lib/components/BirthdayPoller";

ReactDOM.render(
	<React.StrictMode>
		<SocketProvider>
			<BookingReminderPoller />
			<BirthdayPoller />
			<App />
		</SocketProvider>
	</React.StrictMode>,
	document.getElementById("root")
);
